/* eslint-disable no-unused-vars */
/* eslint-disable no-alert */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-debugger */
/* eslint-disable no-console */
import * as Sentry from "@sentry/react";
import {
  INITIATE_VIEW_INTRODUCTION_REMARKS_DATA,
  INTIATE_VIEW_INTRODUCTION_DATA,
  SET_VIEW_INTRODUCTION_DATA,
  SET_VIEW_INTRODUCTION_REMARKS_DATA,
} from "../actionTypes/dashboard";

import ViewIntroductionAPI from "../../services/api/viewIntroduction";

// const authToken = localStorage.getItem("authToken");

// eslint-disable-next-line import/prefer-default-export
export const fetchIntroductionData = async (dispatch, type) => {
  dispatch({
    type: INTIATE_VIEW_INTRODUCTION_DATA,
    payload: {
      pageNumber: 0,
      pageSize: 5,
      type,
    },
  });
};

export const fetchIntroductionRemarksData = async (dispatch, introId) => {
  dispatch({
    type: INITIATE_VIEW_INTRODUCTION_REMARKS_DATA,
  });
  const result = await ViewIntroductionAPI.getIntroductionRemarksData({
    id: introId,
  });

  dispatch({
    type: SET_VIEW_INTRODUCTION_REMARKS_DATA,
    payload: result.data,
  });
};

export const forwardIntro = async (
  payload,
  introData,
  navigate,
  setShowToast
) => {
  try {
    await ViewIntroductionAPI.forwardIntroduction({
      data: payload,
      id: introData.introductionId,
    });
    setShowToast({
      message: "Successfully forward!",
      severity: "success",
    });
    setTimeout(() => {
      navigate("/introduction/view");
    }, 2000);
  } catch (err) {
    setShowToast({
      message: err.message || "Something went wrong. Please contact support.",
      severity: "error",
    });
    Sentry.captureException(err);
  }
};

export const addRemark = async (dispatch, remark, introId) => {
  const result = await ViewIntroductionAPI.addRemark({
    data: { data: remark },
    id: introId,
  });

  fetchIntroductionRemarksData(dispatch, introId);
};

export const rejectIntro = async (
  dispatch,
  introData,
  selectedIntro,
  navigate,
  setShowToast
) => {
  try {
    await ViewIntroductionAPI.rejectIntroduction({
      data: { reason: { data: introData } },
      id: selectedIntro.id,
    });
    setShowToast({
      message: "Successfully Reject!",
      severity: "success",
    });
    setTimeout(() => {
      navigate("/introduction/view");
    }, 2000);
  } catch (err) {
    setShowToast({
      message: err.message || "Something went wrong. Please contact support.",
      severity: "error",
    });
    Sentry.captureException(err);
  }
};
